import { InjectionToken } from "@angular/core";
import { Vitally } from "./vitally/vitally.interfaces";

export const VITALLY_TOKEN = new InjectionToken<Vitally>("window.Vitally");
